import React from 'react';
import qs from 'qs';
import PrismicConfig from './prismic-configuration';

export default class Preview extends React.Component {
  startPreview(prismicCtx) {
    if (!prismicCtx || this.started) {
      return
    }

    const params = qs.parse(this.props.location.search.slice(1));
    if (!params.token) {
      console.warn('Unable to retrieve session token from provided url.');
      return
    }

    this.started = true
    prismicCtx.api.previewSession(params.token, PrismicConfig.linkResolver, '/').then((url) => {
      this.props.history.push(url);
    });
  }

  componentDidMount() {
    this.startPreview(this.props.prismicCtx)
  }

  componentDidUpdate() {
    this.startPreview(this.props.prismicCtx)
  }

  render() {
    return <p>Loading previews...</p>;
  }
}
